export default __webpack_public_path__ + "static/media/emptyHiredIcon.c2ccc09d.svg";